module.exports = __webpack_public_path__ + "Participant Handout RMR - wave 3.pdf";